import React from "react";
import SignIn from "components/SignIn/SignIn";

const Signin = () => {
  return <SignIn />;
};

export default Signin;
